import { useAProgress } from 'hooks/useAProgress'
import { useSingleEntity } from 'modules/domain/common/hooks'
import * as managers from 'modules/domain/common/managers'
import { DocumentFile, DocumentType, DocumentWithTypeFile } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { AFilesByTypes } from 'views/components/FilesByTypes/AFilesByTypes'

type Props = {
  trailerId: string
}

export const TrailerDocuments: FC<Props> = ({ trailerId }) => {
  const [, documentTypes = []] = useSingleEntity<DocumentType[]>(
    endpoints.LogisticsKR.trailerDocumentsTypes(trailerId),
    false,
  )
  const [, documents = [], documentsRefetch] = useSingleEntity<DocumentFile[]>(
    endpoints.LogisticsKR.trailerDocuments(trailerId),
    false,
  )

  const [uploadProgress, upload] = useAProgress<DocumentWithTypeFile[]>(
    (documentType: DocumentType['slug'], files: File[]) => {
      const promises: Promise<DocumentWithTypeFile>[] = []
      for (const file of files) {
        promises.push(managers.uploadDocuments(endpoints.LogisticsKR.trailerDocuments(trailerId), documentType, file))
      }
      return Promise.all(promises)
    },
    {
      eventName: 'uploadDocument',
      onSuccess: () => documentsRefetch(),
    },
  )

  const [removeProgress, removeDoc] = useAProgress(
    (documentId: string) => apiClient.delete(endpoints.LogisticsKR.trailerDocument(trailerId, documentId)),
    {
      eventName: 'deleteDocument',
      onSuccess: () => documentsRefetch(),
    },
  )

  return (
    <AFilesByTypes
      uploadProgress={uploadProgress}
      deleteProgress={removeProgress}
      types={documentTypes}
      files={documents}
      onUpload={upload}
      onDelete={removeDoc}
    />
  )
}
